import React, { Component } from 'react';
import { Col, Container, Row, Form, Button } from 'reactstrap';
import { InputQuestionCurrency, InputQuestionPercent} from '../Inputs/InputQuestions';

export class MortgageCalculator extends Component {
    displayName = MortgageCalculator.name

    constructor(props) {
        super(props);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.save = this.save.bind(this);
        this.cancel = this.cancel.bind(this);
        this.state = {
            purchasePrice: 0,
            ltv: 65,
            interestRate: 3.39
        };
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;
        this.setState({
            [name]: value
        });
    }

    mortgage() {
        return Math.floor(this.state.purchasePrice * (this.state.ltv / 100));
    }

    mortgageRepayments() {
        return Math.floor(this.mortgage() * (this.state.interestRate / 100));
    }

    save() {
        this.props.mortCalcSave(this.mortgageRepayments());
    }

    cancel() {
        this.props.mortCalcHide();
    }

    render() {

        return (
            <Form>
                <InputQuestionCurrency name="purchasePrice" value={this.state.purchasePrice} title="Purchase price" onChange={this.handleInputChange} />
                <InputQuestionPercent name="ltv" value={this.state.ltv} title="LTV" onChange={this.handleInputChange} />
                <InputQuestionCurrency name="mortgage" value={this.mortgage()} title="Mortgage"  />
                <InputQuestionPercent name="interestRate" value={this.state.interestRate} title="Interest rate" onChange={this.handleInputChange} />
                <InputQuestionCurrency name="mortgageRepayments" value={this.mortgageRepayments()} title="Mortgage repayments" />
                <Button color="primary" onClick={this.save}>Save</Button>{' '}
                <Button outline color="secondary" onClick={this.cancel} > Cancel</Button>
            </Form>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/MortgageCalculator/MortgageCalculator.js